import { useEffect } from 'react';
import AuthService from '../services/authService';
import tokenRefreshService from '../services/tokenRefreshService';

export const useAuth = () => {
  useEffect(() => {
    // Check if user is authenticated and start token refresh if needed
    if (AuthService.isAuthenticated()) {
      console.log('User is authenticated, starting token refresh service');
      tokenRefreshService.startTokenRefresh();
    }

    // Cleanup on unmount
    return () => {
      tokenRefreshService.stopTokenRefresh();
    };
  }, []);

  return {
    isAuthenticated: AuthService.isAuthenticated,
    getAccessToken: AuthService.getAccessToken,
    logout: () => {
      tokenRefreshService.stopTokenRefresh();
      AuthService.logout();
    }
  };
}; 